import React from "react";
import { Navigate, Route } from "react-router-dom";
import RequestTimeOff from "Pages/AdministratorDashboard/RequestTimeOff/RequesttimeOff";
import SignIn from "Pages/AdministratorDashboard/authentication/sign-in";
import Personal from "Pages/AdministratorDashboard/Personal/Personal";
import Job from "Pages/AdministratorDashboard/Job/Job";
import Emergency from "Pages/AdministratorDashboard/Emergency/Emergency";
import Documents from "Pages/AdministratorDashboard/Documents/Documents";
import Assets from "Pages/AdministratorDashboard/Assets/Assets";
import Onboarding from "Pages/AdministratorDashboard/Onboarding/Onboarding";
import ViewCareer from "Pages/AdministratorDashboard/View Career Page/ViewCareerPage";
import JobOpenings from "Pages/AdministratorDashboard/View Career Page/JobOpenings";
import ViewCandidate from "Pages/AdministratorDashboard/Hiring/ViewCandidate";
import EmployeeDetail from "./Organization/Employee/EmployeeDetail";
import HumanResource from "Pages/AdministratorDashboard/ParentComponent/ParentComponent";
import ExpenseManagement from "Pages/AdministratorDashboard/ExpenseManagment/index";
import AddPolicy from "Pages/AdministratorDashboard/Compliance/Complaince";
import HiringOnboarding from "Pages/AdministratorDashboard/Hiring/HiringOnboarding/HiringOnboarding";
import ComplaintDetail from "Pages/AdministratorDashboard/Complaints/ComplaintDetail";
import SkillsReport from "Pages/AdministratorDashboard/Report/SkillsReport/SkillsReport";
import PerformanceManagementDetail from "Pages/AdministratorDashboard/PerformanceManagement/PerformanceManagementDetail";
import DocumentManager from "Pages/AdministratorDashboard/DocumentManager/DocumentManager";
import OfferLetter from "Pages/AdministratorDashboard/dashboard/DocumentCardChild/OfferLetter/OfferLetter";
import SpecRecruitment from "Pages/AdministratorDashboard/dashboard/DocumentCardChild/SpecRecruitment/SpecRecruitment";
import RecruitmentIntegration from "Pages/AdministratorDashboard/dashboard/DocumentCardChild/RecruitmentIntegration/RecruitmentIntegration";
import OnboardingBackground from "Pages/AdministratorDashboard/dashboard/DocumentCardChild/OnboardingBackground/OnboardingBackground";
import ProtectedHRRoute from "Pages/AdministratorDashboard/authentication/ProtectedHRFile/ProtectedHRFile";
import CorrectiveActionForm from "Pages/AdministratorDashboard/Complaints/CorrectiveActionForm";
import ViweCorrectiveDetail from "Pages/AdministratorDashboard/Complaints/ViewCorrectiveComplaintAction";
import SoftwareInputFields from "Pages/AdministratorDashboard/Assets/SoftwareInputFields";
import NotFound from "404NotFound";
import SoftwareAssets from "Pages/AdministratorDashboard/Assets/SoftwareInputFields";
import HardwareAssets from "Pages/AdministratorDashboard/Assets/HardwareInputFields";
import DocumentPreview from "Pages/AdministratorDashboard/DocumentsStore/DocPreview";
import AnnouncementDetail from "./dashboard/components/Announcement/AnnuncementDetail";
import SetPassword from "../SetPassword";
import DeptAttendance from "Pages/AdministratorDashboard/Attendence/Attendence";
import EmployeeAttendanceReport from "./Report/EmployeeAttendance/EmployeeAttendanceReport";
import EmployeeOnLeaveReport from "./Report/EmployeeOnLeaveReoprt";
import DepartmentDetail from "./Organization/DepartmentDetail";
import { CreateJobTile } from "./Organization/CreateJobTitle";

const RedirectToHRDashboard = () => <Navigate to="/dashboard" />;
const HRRoutes = () => (
  <React.Fragment>
    <Route path="*" element={<NotFound />} />
    <Route path="/" element={<ProtectedHRRoute element={<RedirectToHRDashboard />} />} />
    <Route path="/signIn" name="Sign In" element={<SignIn />} />
    <Route path="/set-password" name="set-password" element={<SetPassword />} />
    <Route
      path="/personal/"
      name="Personal"
      element={<ProtectedHRRoute element={<Personal />} />}
    />
    <Route 
      path="/department-detail/:departmentId"
      name="Department Detail"
      element={<DepartmentDetail/>}
      />
      <Route 
      path="/create-jobtitle/:departmentId"
      name="Create JobTitle"
      element={<CreateJobTile/>}
      />
       <Route 
      path="/edit-jobtitle/:jobTitleId"
      name="Edit JobTitle"
      element={<CreateJobTile/>}
      />
      
    
    <Route path="/job" name="Job" element={<ProtectedHRRoute element={<Job />} />} />
    <Route
      path="/softwareAssets"
      name="Software Assets"
      element={<ProtectedHRRoute element={<SoftwareInputFields />} />}
    />
    <Route
      path="/emergency"
      name="Emergency"
      element={<ProtectedHRRoute element={<Emergency />} />}
    />
      <Route
      path="/documents"
      name="Documents"
      element={<ProtectedHRRoute element={<Documents />} />}
    />
    <Route
      path="/document-preview"
      name="Document-preview"
      element={<ProtectedHRRoute element={<DocumentPreview />} />}
    />
    <Route
      path="/documentsManagers"
      name="Document Manager"
      element={<ProtectedHRRoute element={<DocumentManager />} />}
    />
    <Route path="/assets" name="Assets" element={<ProtectedHRRoute element={<Assets />} />} />
    <Route
      path="/onboarding/:jobApplicantId"
      name="On boarding"
      element={<ProtectedHRRoute element={<Onboarding />} />}
    />
    <Route
      path="/hiringOnboarding/:jobApplicantId"
      name="On boarding"
      element={<ProtectedHRRoute element={<HiringOnboarding />} />}
    />
    <Route
      path="/attendance"
      name="Attendance"
      element={<ProtectedHRRoute element={<DeptAttendance />} />}
    />
    
    <Route path="/viewcareer" name="View Career" element={<ViewCareer />} />
    <Route path="/jobOpenings/:jobPostingId" name="JobOpenings" element={<JobOpenings />} />
    <Route
      path="/viewcandidate/:id"
      name="View Candidate"
      element={<ProtectedHRRoute element={<ViewCandidate />} />}
    />
    <Route
      path="/employeeDetail/:empId"
      name="Employee Details"
      element={<ProtectedHRRoute element={<EmployeeDetail />} />}
    />
    <Route
      path="/requestTimeOff"
      name="Request Time Off"
      element={<ProtectedHRRoute element={<RequestTimeOff />} />}
    />
    <Route
      path="/humanResource/:jobApplicantId"
      element={<ProtectedHRRoute element={<HumanResource />} />}
    />
    <Route
      path="/humanResource/:personalId"
      element={<ProtectedHRRoute element={<HumanResource />} />}
    />

    <Route
      path="/complaintDetail/:id/:complainantEmployeeId"
      name="Complaint Detail"
      element={<ProtectedHRRoute element={<ComplaintDetail />} />}
    />
    <Route
      path="/expenseManagement"
      name="Expense Management"
      element={<ProtectedHRRoute element={<ExpenseManagement />} />}
    />
    <Route
      path="/addPolicy"
      name="Add Policy"
      element={<ProtectedHRRoute element={<AddPolicy />} />}
    />
    <Route
      path="/attendance-report"
      name="Reports Attendance"
      element={<ProtectedHRRoute element={<EmployeeAttendanceReport />} />}
    />
    <Route
      path="/leave-report"
      name="TimeOff"
      element={<ProtectedHRRoute element={<EmployeeOnLeaveReport />} />}
    />
    <Route
      path="/performance/detail"
      element={<ProtectedHRRoute element={<PerformanceManagementDetail />} />}
    />
    <Route
      path="/offerLetters"
      name="Offer Letter"
      element={<ProtectedHRRoute element={<OfferLetter />} />}
    />
    <Route
      path="/specRecruitment"
      name="Spec Recruitment"
      element={<ProtectedHRRoute element={<SpecRecruitment />} />}
    />
    <Route
      path="/recruitment-Integration"
      name="Recruitment Integration"
      element={<ProtectedHRRoute element={<RecruitmentIntegration />} />}
    />
    <Route
      path="/onboardingBackground"
      name="Onboarding Background"
      element={<ProtectedHRRoute element={<OnboardingBackground />} />}
    />
    
    <Route
      path="/announcement-detail/:announcementId"
      element={<ProtectedHRRoute element={<AnnouncementDetail />} />}
    />
    <Route path="/skillsReport" element={<ProtectedHRRoute element={<SkillsReport />} />} />


    <Route
      path="/corrective-action-form/:id/:complainantEmployeeId"
      name="corrective-action-form"
      element={<ProtectedHRRoute element={<CorrectiveActionForm />} />}
    />
    <Route
      path="/view-corrective-action-form/:id"
      name="view corrective-action-form"
      element={<ProtectedHRRoute element={<ViweCorrectiveDetail />} />}
    />
    
    <Route
      path="/software-assets"
      name="SoftwareAssets"
      element={<ProtectedHRRoute element={<SoftwareAssets />} />}
    />
    <Route
      path="/hardware-assets"
      name="hardwareAssets"
      element={<ProtectedHRRoute element={<HardwareAssets />} />}
    />
  </React.Fragment>
);

export default HRRoutes;
